export default function FinishLineRow(props) {
    return (
        <div className="grid grid-cols-12 gap-2 bg-white rounded-xl p-2" >
            <div className="col-span-2">
                <div className="col-span-12 text-right font-bold">
                    {props.result.category}
                </div>
                <div className="col-span-12 text-right">
                    {props.result.place}
                </div>
            </div>
            <div className="col-span-7">
                <div className="col-span-12 text-left font-bold">
                    {props.result.name}
                </div>
                <div className="col-span-12 text-left">
                    {props.result.club}
                </div>
            </div>
            <div className="col-span-3">
                <div className="col-span-12 text-right font-bold">
                    {props.result.result.time}
                </div>
                <div className="col-span-12 text-right">
                    +{props.result.result.timeLoss}
                </div>
            </div>
        </div>
    )
}